import { useLingui } from '@lingui/react/macro';
import { CheckboxDropdown, Skeleton } from '@repo/videa-components/src';
import { isToday } from 'date-fns';
import { useAtom, useAtomValue } from 'jotai';

import type { AppointmentProvider } from '../../react-query/useAppointments';
import { mixpanelEvents, useTrackEvent } from '../../utils/mixpanel';

import { selectDateAtom, selectedProvidersAtom } from './atoms';
import { getProviderName } from './huddlePrintoutContent/helpers';

interface Props {
  loading?: boolean;
  providersList: AppointmentProvider[];
}

export const ProvidersDropdown = ({ loading, providersList }: Props) => {
  const [selectedProviders, setSelectedProviders] = useAtom(
    selectedProvidersAtom,
  );
  const selectedDate = useAtomValue(selectDateAtom);
  const { trackEvent } = useTrackEvent();
  const { t } = useLingui();

  const handleChange = (newProviders: AppointmentProvider[]) => {
    trackEvent(mixpanelEvents.selectProvider, {
      date: selectedDate,
      isToday: selectedDate ? isToday(selectedDate) : false,
    });
    setSelectedProviders(newProviders);
  };

  if (loading) {
    return <Skeleton className="vai-h-11" />;
  }

  return (
    <CheckboxDropdown
      getItemLabel={getProviderName}
      getItemValue={(provider) => provider?.id ?? ''}
      items={providersList}
      onChange={handleChange}
      placeholder={
        selectedProviders.length
          ? selectedProviders.map(getProviderName).join(', ')
          : t`All Providers`
      }
      selectedItems={selectedProviders}
      type="providers"
    />
  );
};
